module.exports = {
	"smartling": {
		"translate_mode": "all",
		"source_key_paths": [
			"{*}"
		],
		"placeholder_format_custom": [
			"%\\{([^\\}]*)\\}"
		],
		"variants_enabled": true
	},
	"base": {
		"welcome": "Welcome to Mulligans, %{name}!",
		"user": "User Info",
		"devices": "Devices",
		"refunds": "Refunds",
		"resources": "Resources",
		"transactions": "Orders & Returns",
		"email": "Email",
		"password": "Password",
		"save": "Save",
		"sign-out": "Sign Out",
		"cancel": "Cancel",
		"close": "Close",
		"learn-more": "Learn more",
		"required": "Required",
		"support": "Support",
		"bookshelf": "Bookshelf",
		"launch": "Launch",
		"download": "Download",
		"details": "Details",
		"cannot-be-blank": "%{field} cannot be blank.",
		"saving": "Saving...",
		"done": "Done",
		"failed": "Failed",
		"copy": "Copy"
	},
	"signin": {
		"login-failure": "Email or password is incorrect",
		"welcome-large": "Welcome to <span class='inner'>%{brand} Account Center</span>",
		"welcome-small": "<span class='inner'>Account Center</span>",
		"signin-button": "Sign In",
		"forgot-password": "Forgot your Password",
		"new-to-vst": "New to %{brand}?",
		"create-account": "Create an account",
		"signing-in": "Signing in...",
		"signin-failed": "Sign-in failed"
	},
	"transactions": {
		"price": "Price",
		"excluded": "(Excluding tax)",
		"quantity": "Quantity",
		"confirmation#": "Confirmation #",
		"payment": "Payment",
		"purchased": "Purchased",
		"purchase-details": "Purchase Details",
		"subtotal": "Subtotal",
		"total": "Total",
		"tax": "Tax",
		"loading": "Hey big spender, we're loading your transactions...",
		"no-purchases": "You have no purchases.",
		"seller-vat": "Seller VAT",
		"total-vat": "Total %{vat} Paid",
		"portion": "%{subTax} Tax %{rate}%",
		"vat-disclosure": "Price Includes %{vat}",
		"purchases": "Purchases",
		"refunded-items": "Refunded Items",
		"book-title": "Book Title",
		"refund-details": "Refund Details",
		"print-receipt": "Print Receipt",
		"request-refund": "Request Refund",
		"expired": "Expired",
		"expires-in": "Expires %{date}",
		"details-refund": "Details & Refund",
		"modal": {
			"cant-refund-title": "Refund Not Available",
			"cant-refund": "Your book cannot be refunded because of one or more of the following reasons.",
			"cant-refund-1": "Too much of your book has been viewed.",
			"cant-refund-2": "It has been more than 14 days from the purchase date.",
			"cant-refund-3": "Your online resources code has been revealed.",
			"cant-refund-4": "Your book has previously been refunded.",
			"cant-refund-5": "All codes have already been redeemed and/or refunded.",
			"cant-refund-6": "It has been more than 30 days from the purchase date.",
			"cant-refund-support": "If you are still unsure of %{brand}'s refund policy, contact <a href='%{support_url}' target='_blank'>support</a>."
		},
		"license": {
			"perpetual": "Online access does not expire",
			"days": "%{days} Day Access"
		}
	},
	"devices": {
		"description": "%{brand} allows you to have <span>%{desktop}</span> computers and <span>%{mobile}</span> mobile/tablet devices activated at any given time.",
		"loading": "Heya, we're getting your devices :)",
		"no-active": "You have no active devices.",
		"deactivate": "Deactivate"
	},
	"user": {
		"personal-information": "Personal Information",
		"security-information": "Security Information",
		"notifications": "Notifications",
		"first-name": "First Name",
		"last-name": "Last Name",
		"change-password-title": "Change Password",
		"current-password": "Current Password",
		"new-password": "New Password",
		"security-password": "Password",
		"confirm-new-password": "Confirm New Password",
		"security-question": "Security Question",
		"security-info-change": "Change",
		"question": "Question",
		"answer": "Answer",
		"notifications-text": "Email me occasional updates about my account activity, product updates, and special offers.",
		"loading": "Spot is out fetching your user information, one sec 🐶",
		"change-password-text": "Password must contain at least 8 characters, an uppercase letter, a lower case letter, and a special character.",
		"email-locked": "Email Locked",
		"email-locked-description": "You do not have access to change your email.",
		"email-locked-more": "Please contact your administrator.",
		"security-question6": "What is your favorite sport?",
		"security-question7": "What is your favorite flavor of ice cream?",
		"security-question8": "What is the name of your favorite pet?",
		"security-question9": "When you were young, what did you want to be when you grew up?",
		"security-question10": "What was the last name of your favorite teacher?",
		"new-password-failure": "Password doesn't meet requrements",
		"confirm-password-failure": "Password must match",
		"new-password-tooltip": "Must contain at least 8 characters, an uppercase letter, a lowercase letter, and a special character.",
		"enter-valid-email": "Please enter a valid email.",
		"password-cannot-be-same": "Password can not be the same as the previous password",
		"incorrect-password": "Incorrect Password",
		"complete-account": "Looks like you need to <a href='%{href}'>complete your account</a>.",
		"completing-allows": "Completing your account allows you to read books offline on our mobile apps and share notes and highlights with friends.",
		"error-updating-info": "There was an error updating your information.",
		"password-updated": "Password successfully updated",
		"security-updated": "Security question successfully updated",
		"info-updated": "User information successfully updated"
	},
	"resources": {
		"ancillaries": "Ancillaries",
		"access-codes": "Access Codes",
		"print-on-demand": "Print on Demand",
		"check-pod": "Check publisher printing options for your books.",
		"check-now": "Check Now",
		"loading": "Hang tight, we are updating your resources!",
		"in": "in",
		"access-code-intro": "An access code is a password you use to access course content online. Once you reveal a code for an item, you will not be able to return it. For more instructions on how to use your access codes, visit <a href='%{support_url}' target='_blank'>Support</a>.",
		"expires": "Expires",
		"expiration-message": "Contains instructions for using your access code.",
		"copy-fail": "Unable to copy. Please select the code and manually copy it.",
		"launch-site": "Launch Site",
		"launch-book": "Launch Book",
		"reveal-code": "Reveal Code",
		"no-resources": "You do not have any resources.",
		"no-access-codes": "You do not have any access codes.",
		"no-ancillaries": "No ancillaries for this title",
		"name": "Name",
		"type": "Type",
		"size": "Size",
		"download-all": "Download All",
		"back": "Back to resources"
	},
	"refunds": {
		"states": {
			"refunded": "Refunded",
			"unavailable": "Refund Unavailable"
		},
		"reasons": {
			"dropped": "I dropped the course",
			"wrong": "This was the wrong book for my course",
			"print": "I decided to buy a print version instead",
			"missing": "The book does not contain everything I need for my course (eg. a CD, web access, videos)",
			"other": "Other"
		},
		"bulk": {
			"policy": "By clicking  the \"Complete Refund\" button below, I am agreeing to %{brand}'s <a href='%{policy_url}' target='_blank'>refund policy</a>.",
			"complete": "Complete Refund",
			"view-details": "View Refund Details",
			"success": "Your refund request has been received and will be processed in 24-48 hours.",
			"failure": "Oops - something went wrong! Unfortunately your refund didn't go through.",
			"retry": "Try Again",
			"support": "Contact Support",
			"available-codes": "Available Codes",
			"codes-selected": "Codes Selected",
			"download": "Download Codes",
			"partially-refunded": "Partially Refunded",
			"pick-one": "You must select at least one code to make a refund"
		},
		"refund": "Refund",
		"all": "Refund All?",
		"missing-reason": "You must select a reason to continue",
		"missing-elaboration": "Please elaborate",
		"policy": "By clicking the “Complete Refund Request” button below, I understand that if I purchase this %{brand} eTextbook again, I will not be eligible to request any further refunds for the same eTextbook. View full return policy.",
		"refunded": "Refunded",
		"sorry": "We are sorry you were not satisfied with your purchase.",
		"error": "Something went wrong",
		"error-explain": "We were unable to process your refund. Please try again.",
		"why": "Tell us why?",
		"no-refunds": "You have no refunded items.",
		"select-codes": "Select code(s) to refund:",
		"number": "How many?",
		"back": "Back to refunds"
	},
	"purchases": {
		"back": "Back to purchases"
	},
	"global-bar": {
		"account": "Account Settings"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/locales/en.json
 ** module id = 1002
 ** module chunks = 0
 **/